/* eslint-disable no-console */
/*
 * Script to normalize Ricos Document inside json files
 * run this with `bun normalize-ricos-document-script.ts <path-to-json-file1> <path-to-json-file2> ...`
 */
import fs from 'fs';
import path from 'path';

import { normalizeRicosDocument } from './normalize-ricos-document';

// Function to read, transform, and write JSON files
function processJsonFiles(filePaths, transformFunction) {
  filePaths.forEach(filePath => {
    const absolutePath = path.resolve(filePath);

    // Read the JSON file
    fs.readFile(absolutePath, 'utf8', (err, data) => {
      if (err) {
        console.error(`Error reading file ${absolutePath}:`, err);
        return;
      }

      try {
        // Parse the JSON data
        let jsonData = JSON.parse(data);

        // Apply the transformation
        jsonData = transformFunction(jsonData);

        // Write the transformed JSON back to the file
        fs.writeFile(absolutePath, JSON.stringify(jsonData, null, 2), 'utf8', err => {
          if (err) {
            console.error(`Error writing file ${absolutePath}:`, err);
          } else {
            console.log(`File ${absolutePath} has been updated.`);
          }
        });
      } catch (err) {
        console.error(`Error processing file ${absolutePath}:`, err);
      }
    });
  });
}

// List of relative file paths to process (modify this as needed)
const filePaths = process.argv.slice(2);

// Process the JSON files
processJsonFiles(filePaths, normalizeRicosDocument);
